"use strict";

exports.__esModule = true;
exports.default = void 0;
var config = {
  host: ''
};
var _default = config;
exports.default = _default;